import { render, staticRenderFns } from "./BoardWriteLink.vue?vue&type=template&id=0ed788f0&scoped=true"
import script from "./BoardWriteLink.vue?vue&type=script&lang=js"
export * from "./BoardWriteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed788f0",
  null
  
)

export default component.exports